import { CurrencyType, CurrencyTypes } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { AppTextService } from '@fi-shared/app-text';
import { Injectable } from '@angular/core';
import { CustomerBillingInvoiceDetailModel } from '@fi-app/customer-billing/customer-billing-invoice/customer-billing-invoice-detail.model';
import { createMap } from '@fi-shared/utils/create-map';

@Injectable()
export class CustomerBillingHelperService {
    private CurrencyTypesMap: {
        [prop: number]: { TextId: string; Id: CurrencyType };
    };

    constructor(private appTextService: AppTextService) {
        this.CurrencyTypesMap = createMap(CurrencyTypes, 'Id');
    }

    getCurrencyName(currencyType: CurrencyType) {
        const currencyTypeItem = this.CurrencyTypesMap[currencyType];
        if (!currencyTypeItem) {
            return '?';
        }
        return this.appTextService.get(currencyTypeItem.TextId);
    }

    getInvoiceDetailsTotalAmount(invoiceDetail: CustomerBillingInvoiceDetailModel) {
        return (
            (parseInt(invoiceDetail.Quantity) || 0) *
            (parseFloat(invoiceDetail.ItemPrice) || 0) *
            (1 - (parseFloat(invoiceDetail.Discount) || 0) / 100)
        );
    }
    getInvoiceTotalAmountExcVat(invoiceDetails: CustomerBillingInvoiceDetailModel[]) {
        let totalAmountExcVat = 0;

        invoiceDetails.forEach((invoiceDetail) => {
            totalAmountExcVat += this.getInvoiceDetailsTotalAmount(invoiceDetail);
        });
        return totalAmountExcVat;
    }
    getInvoiceTotalAmountIncVat(invoiceDetails: CustomerBillingInvoiceDetailModel[], chargeVat: boolean) {
        let totalAmount = this.getInvoiceTotalAmountExcVat(invoiceDetails);
        if (chargeVat) {
            totalAmount = totalAmount * 1.25;
        }
        return totalAmount;
    }
    getInvoiceVATAmount(invoiceDetails: CustomerBillingInvoiceDetailModel[], chargeVat: boolean) {
        if (!chargeVat) {
            return 0;
        }
        return this.getInvoiceTotalAmountExcVat(invoiceDetails) * 0.25;
    }
}
